import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import PropTypes from 'prop-types';
import MainPagesLayout from '../PageLayout/MainPagesLayout/MainPagesLayout';
import HttpErrorMessages from "../TechnicalPage/ErrorPageHandler/HttpErrorMessages/HttpErrorMessages.jsx";

// enable 404 as default route
class DefaultSwitch extends Component {

  render() {
    return (
        <Switch>
          {this.props.children}
          <Route>
            <MainPagesLayout>
              <HttpErrorMessages httpCode="404" />
            </MainPagesLayout>
          </Route>
        </Switch>
    );
  }
}

DefaultSwitch.propTypes = {
  children: PropTypes.any.isRequired
};

export default DefaultSwitch;
